import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-401',
  templateUrl: './401.component.html',
  standalone: false,
})
export class Auth401Component implements OnInit {
  constructor() {}

  ngOnInit() {}
}
